export const searchThemesFromTrendsSettingDrawer = {
    setting: '設定',
    size: 'バブルの大きさ',
    xLabel: 'X軸',
    yLabel: 'Y軸',
    zoomSlider: 'ズームスライダー',
    labelFixMode: 'ラベル固定',
    initButton: '設定の初期化'
}
